import { getMainDomainSuffix } from '@app/shared/helpers/location';
import { Action, createReducer, on } from '@ngrx/store';
import { CreateDomainOutput } from '@smash-sdk/domain/ejs/01-2024';
import { DomainActionsSignup } from '../actions';
import { environment } from 'src/environments/environment';

export const domainFeatureKey = 'domain';

export interface State {
  domain: string;

  domainCreated: CreateDomainOutput['domain'];
  domainCreating: boolean;
  domainCreationFailed: boolean;
  domainCreationError: any;

  teamCreated: boolean;
  teamCreating: boolean;
  teamCreationError: any;
}

export const initialState: State = {
  domain: null,

  domainCreated: null,
  domainCreating: false,
  domainCreationFailed: false,
  domainCreationError: null,

  teamCreated: false,
  teamCreating: false,
  teamCreationError: false,
};

const domainReducer = createReducer(
  initialState,
  on(DomainActionsSignup.updateDomainToCreate, (state, { domain }) => {
    return {
      ...state,
      domain: domain + "." + environment.appDomain,
      domainCreationError: initialState.domainCreationError,
    };
  }),
  on(DomainActionsSignup.createDomain, (state) => ({
    ...state,
    domainCreated: initialState.domainCreated,
    domainCreating: true,
    domainCreationFailed: initialState.domainCreationFailed,
    domainCreationError: initialState.domainCreationError,
  })),
  on(DomainActionsSignup.createDomainSuccess, (state, { domain }) => ({
    ...state,
    domainCreated: domain,
    domainCreating: true,
  })),
  on(DomainActionsSignup.createDomainFailure, (state, { error }) => ({
    ...state,
    domainCreationError: error,
    domainCreationFailed: true,
    domainCreating: false,
  })),
  on(DomainActionsSignup.InitiateTeam, (state) => ({
    ...state,
    teamCreated: initialState.teamCreated,
    teamCreating: initialState.teamCreating,
  })),
  on(DomainActionsSignup.InitiateTeamSuccess, (state) => ({
    ...state,
    teamCreated: true,
    teamCreating: false,
  })),
  on(DomainActionsSignup.InitiateTeamFailure, (state, { error }) => ({
    ...state,
    teamCreationError: error,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return domainReducer(state, action);
}

export const getDomainToCreate = (state: State) => state.domain;
export const getDomainCreated = (state: State) => state.domainCreated;
export const getTeamCreated = (state: State) => state.teamCreated;
export const getDomainCreationFailed = (state: State) => state.domainCreationFailed;
export const getDomainCreating = (state: State) => state.domainCreating;
export const getDomainCreatingError = (state: State) => state.domainCreationError;
export const getDomainError = (state: State) => state.domainCreationError;
